const FrameModelRules = {
  canShowAlertAboutCertificateText: (type: string) => type === 'cnd'
}

export default FrameModelRules
